import { partServiceOne } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      partService: undefined
    };
  },
  created: function() {
    this.partService = partServiceOne;
  }
};
